import { getSeasonalState, buildCampaignCalendar } from './qr-seasonal-calendar.js';
const configNode = [...document.querySelectorAll('[data-qr-seasonal-config]')].at(-1);
let configuration;
try { configuration = JSON.parse(configNode?.textContent || 'null'); } catch {}
if (configuration) {
  let rows = configuration.campaigns || [];
  let campaigns = new Map(rows.map(row => [row.key,row]));
  let state;
  let opener;
  const dialog = document.querySelector('[data-qr-seasonal-dialog]');
  const now = () => configuration.previewDate ? new Date(configuration.previewDate) : new Date();
  const dismissalKey = key => `qr-seasonal-dismissed-${key}-${state?.date.slice(0,4)}`;
  const isDismissed = key => { try { return sessionStorage.getItem(dismissalKey(key)) === 'true'; } catch { return false; } };
  const record = (event,placement,product) => {
    window.dataLayer?.push?.({event,seasonal_campaign:state?.primary,seasonal_placement:placement,...(product ? {seasonal_product:product} : {})});
  };
  const update = () => {
    const base = getSeasonalState({now:now(),timeZone:configuration.timeZone,country:configuration.country});
    const year = Number(base.date.slice(0,4));
    const defaults = buildCampaignCalendar(year,configuration.country);
    const overrides = rows.filter(row => row.key !== 'general' && (row.startMonthDay || row.endMonthDay) && !(configuration.country === 'CA' && row.key === 'thanksgiving')).map(row => {
      const window = defaults.find(window => window.key === row.key);
      return {key:row.key,startMonthDay:row.startMonthDay || window?.start.slice(5),endMonthDay:row.endMonthDay || window?.end.slice(5)};
    });
    state = getSeasonalState({now:now(),timeZone:configuration.timeZone,country:configuration.country,override:configuration.override,campaigns:overrides});
    const spotlightRoots = document.querySelectorAll('[data-qr-seasonal-spotlight]');
    for (const root of spotlightRoots) {
      const panels = [...root.querySelectorAll('[data-qr-season-panel]')];
      const requested = panels.find(panel => panel.dataset.qrSeasonPanel === state.primary);
      const selected = requested || panels.find(panel => panel.dataset.qrSeasonPanel === 'general');
      panels.forEach(panel => { panel.hidden = panel !== selected; });
      root.dataset.activeSeason = selected?.dataset.qrSeasonPanel || 'general';
      const heading = root.querySelector('[data-qr-seasonal-heading]');
      if (heading) heading.textContent = state.primary === 'general' ? heading.dataset.generalHeading : heading.dataset.seasonalHeading;
      const next = campaigns.get(state.next);
      const nextSlot = root.querySelector('[data-qr-seasonal-next]');
      const nextLink = root.querySelector('[data-qr-seasonal-next-link]');
      if (nextSlot && nextLink) {
        nextSlot.hidden = !next;
        if (next) { nextLink.textContent = `${next.linkLabel} →`; nextLink.href = next.url; }
      }
    }
    const campaign = campaigns.get(state.primary) || campaigns.get('general');
    const banner = document.querySelector('[data-qr-seasonal-banner]');
    if (banner && campaign) {
      banner.dataset.season = campaign.key;
      banner.hidden = !configuration.enabled || !configuration.showBanner || isDismissed(campaign.key);
      banner.querySelector('[data-qr-seasonal-banner-message]').textContent = campaign.message;
      const link = banner.querySelector('[data-qr-seasonal-banner-link]');
      link.textContent = `${campaign.linkLabel} ↗`;
      link.href = campaign.url;
      banner.querySelector('[data-qr-seasonal-banner-dismiss]').hidden = false;
      banner.setAttribute('aria-label', campaign.name);
    }
  };
  update();
  const bannerElement = document.querySelector('[data-qr-seasonal-banner]');
  if (bannerElement) {
    const sizeBanner = () => document.documentElement.style.setProperty('--qr-seasonal-banner-height',`${bannerElement.hidden ? 0 : bannerElement.getBoundingClientRect().height}px`);
    new ResizeObserver(sizeBanner).observe(bannerElement);
    sizeBanner();
  }
  record('qr_seasonal_view','page');
  document.querySelector('[data-qr-seasonal-banner-dismiss]')?.addEventListener('click', () => {
    try { sessionStorage.setItem(dismissalKey(state.primary),'true'); } catch {}
    document.querySelector('[data-qr-seasonal-banner]').hidden = true;
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    if (link.matches('[data-qr-seasonal-banner-link]')) record('qr_seasonal_click','banner');
    else if (link.closest('[data-qr-seasonal-spotlight]')) record('qr_seasonal_click','feature',link.dataset.qrSeasonalPreview);
    if (!link.hasAttribute('data-qr-seasonal-preview') || !dialog || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const productNode = [...document.querySelectorAll('[data-qr-seasonal-product]')].find(node => {
      try { return JSON.parse(node.textContent).handle === link.dataset.qrSeasonalPreview; } catch { return false; }
    });
    if (!productNode) return;
    let product;
    try { product = JSON.parse(productNode.textContent); } catch { return; }
    event.preventDefault();
    opener = link;
    dialog.querySelector('[data-qr-seasonal-dialog-title]').textContent = product.title;
    dialog.querySelector('[data-qr-seasonal-dialog-price]').textContent = product.price.replace(/<[^>]+>/g,'');
    const image = dialog.querySelector('[data-qr-seasonal-dialog-image]');
    image.src = product.image;
    image.alt = product.title;
    const list = dialog.querySelector('[data-qr-seasonal-dialog-rounds]');
    list.replaceChildren(...product.rounds.map(round => { const li = document.createElement('li'); li.textContent = round; return li; }));
    const isFeud = product.kind.startsWith('feud');
    list.hidden = isFeud;
    dialog.querySelector('[data-qr-seasonal-dialog-rounds-heading]').hidden = isFeud;
    dialog.querySelector('[data-qr-seasonal-dialog-feud]').hidden = !isFeud;
    const notice = dialog.querySelector('[data-qr-seasonal-dialog-notice]');
    notice.textContent = isFeud ? notice.dataset.feudNotice : notice.dataset.triviaNotice;
    dialog.querySelector('[data-qr-seasonal-dialog-link]').href = product.url;
    dialog.showModal();
  });
  dialog?.querySelector('[data-qr-seasonal-close]').addEventListener('click', () => dialog.close());
  dialog?.addEventListener('close', () => opener?.focus({preventScroll:true}));
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  document.addEventListener('shopify:section:load',() => {
    const latest = [...document.querySelectorAll('[data-qr-seasonal-config]')].at(-1);
    try {
      configuration = JSON.parse(latest.textContent);
      rows = configuration.campaigns || [];
      campaigns = new Map(rows.map(row => [row.key,row]));
    } catch {}
    update();
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  window.addEventListener('pageshow',update);
  setInterval(() => { if (!document.hidden) update(); },60000);
}
